"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonSnapAdImpressionTrack = void 0;
const topsnap_volumes_1 = require("./topsnap_volumes");
const dpa_metadata_1 = require("./dpa_metadata");
const swipe_sensitivity_1 = require("./swipe_sensitivity");
const exit_event_swipe_info_1 = require("./exit_event_swipe_info");
const sticker_metadata_1 = require("./sticker_metadata");
const ad_interaction_1 = require("./ad_interaction");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
function createBaseCommonSnapAdImpressionTrack() {
    return {
        topsnapTimeViewedSeconds: undefined,
        topsnapMediaDurationSeconds: undefined,
        longformTimeViewedSeconds: undefined,
        swiped: undefined,
        deltaBetweenReceiveAndRenderMillis: undefined,
        swipeCount: undefined,
        creativeId: new Uint8Array(),
        topsnapTimeViewedBeforeInteractionSeconds: undefined,
        topsnapVolumes: undefined,
        topsnapMaxContinuousTimeViewedSeconds: undefined,
        topsnapAudibleTimeViewedSeconds: undefined,
        topsnapMediaType: 0,
        wasPrefetched: undefined,
        unskippableDurationSeconds: undefined,
        unskippableViewTimeSeconds: undefined,
        adSkippableType: 0,
        fatalMediaLoadError: undefined,
        wasBoosted: undefined,
        autoEndCardInteractionCount: undefined,
        dpa: undefined,
        autoEndCardViewedCount: undefined,
        adResponseParseCompleteTsMs: undefined,
        adInsertionCompleteTsMs: undefined,
        topsnapFullyPresentTsMs: undefined,
        ctaInteractableTsMs: undefined,
        attachmentPageLoadedTsMs: undefined,
        attachmentTriggeredTsMs: undefined,
        attachmentFullyPresentedTsMs: undefined,
        attachmentDismissTriggerTsMs: undefined,
        topsnapDimissTriggerTsMs: undefined,
        ctaWillDisplayTsMs: undefined,
        ctaDidDisplayTsMs: undefined,
        topsnapPlaybackBeginTsMs: undefined,
        preferredAttachmentType: 0,
        actualAttachmentType: 0,
        isExternalAttachment: undefined,
        swipeSensitivity: undefined,
        exitEventSwipeInfo: undefined,
        stickerMetadata: [],
        adCtaCardType: 0,
        adInteraction: undefined,
        attemptSwipeCount: undefined,
    };
}
exports.CommonSnapAdImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.topsnapTimeViewedSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.topsnapTimeViewedSeconds }, writer.uint32(10).fork()).ldelim();
        }
        if (message.topsnapMediaDurationSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.topsnapMediaDurationSeconds }, writer.uint32(18).fork()).ldelim();
        }
        if (message.longformTimeViewedSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.longformTimeViewedSeconds }, writer.uint32(26).fork()).ldelim();
        }
        if (message.swiped !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.swiped }, writer.uint32(34).fork()).ldelim();
        }
        if (message.deltaBetweenReceiveAndRenderMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.deltaBetweenReceiveAndRenderMillis }, writer.uint32(42).fork()).ldelim();
        }
        if (message.swipeCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.swipeCount }, writer.uint32(50).fork()).ldelim();
        }
        if (message.creativeId.length !== 0) {
            writer.uint32(58).bytes(message.creativeId);
        }
        if (message.topsnapTimeViewedBeforeInteractionSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.topsnapTimeViewedBeforeInteractionSeconds }, writer.uint32(66).fork()).ldelim();
        }
        if (message.topsnapVolumes !== undefined) {
            topsnap_volumes_1.TopsnapVolumes.encode(message.topsnapVolumes, writer.uint32(74).fork()).ldelim();
        }
        if (message.topsnapMaxContinuousTimeViewedSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.topsnapMaxContinuousTimeViewedSeconds }, writer.uint32(82).fork()).ldelim();
        }
        if (message.topsnapAudibleTimeViewedSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.topsnapAudibleTimeViewedSeconds }, writer.uint32(90).fork()).ldelim();
        }
        if (message.topsnapMediaType !== 0) {
            writer.uint32(96).int32(message.topsnapMediaType);
        }
        if (message.wasPrefetched !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.wasPrefetched }, writer.uint32(106).fork()).ldelim();
        }
        if (message.unskippableDurationSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.unskippableDurationSeconds }, writer.uint32(114).fork()).ldelim();
        }
        if (message.unskippableViewTimeSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.unskippableViewTimeSeconds }, writer.uint32(122).fork()).ldelim();
        }
        if (message.adSkippableType !== 0) {
            writer.uint32(128).int32(message.adSkippableType);
        }
        if (message.fatalMediaLoadError !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.fatalMediaLoadError }, writer.uint32(138).fork()).ldelim();
        }
        if (message.wasBoosted !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.wasBoosted }, writer.uint32(146).fork()).ldelim();
        }
        if (message.autoEndCardInteractionCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.autoEndCardInteractionCount }, writer.uint32(154).fork()).ldelim();
        }
        if (message.dpa !== undefined) {
            dpa_metadata_1.DpaMetadata.encode(message.dpa, writer.uint32(162).fork()).ldelim();
        }
        if (message.autoEndCardViewedCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.autoEndCardViewedCount }, writer.uint32(170).fork()).ldelim();
        }
        if (message.adResponseParseCompleteTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.adResponseParseCompleteTsMs }, writer.uint32(178).fork()).ldelim();
        }
        if (message.adInsertionCompleteTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.adInsertionCompleteTsMs }, writer.uint32(186).fork()).ldelim();
        }
        if (message.topsnapFullyPresentTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.topsnapFullyPresentTsMs }, writer.uint32(194).fork()).ldelim();
        }
        if (message.ctaInteractableTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.ctaInteractableTsMs }, writer.uint32(202).fork()).ldelim();
        }
        if (message.attachmentPageLoadedTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.attachmentPageLoadedTsMs }, writer.uint32(210).fork()).ldelim();
        }
        if (message.attachmentTriggeredTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.attachmentTriggeredTsMs }, writer.uint32(218).fork()).ldelim();
        }
        if (message.attachmentFullyPresentedTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.attachmentFullyPresentedTsMs }, writer.uint32(226).fork()).ldelim();
        }
        if (message.attachmentDismissTriggerTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.attachmentDismissTriggerTsMs }, writer.uint32(234).fork()).ldelim();
        }
        if (message.topsnapDimissTriggerTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.topsnapDimissTriggerTsMs }, writer.uint32(242).fork()).ldelim();
        }
        if (message.ctaWillDisplayTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.ctaWillDisplayTsMs }, writer.uint32(250).fork()).ldelim();
        }
        if (message.ctaDidDisplayTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.ctaDidDisplayTsMs }, writer.uint32(258).fork()).ldelim();
        }
        if (message.topsnapPlaybackBeginTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.topsnapPlaybackBeginTsMs }, writer.uint32(266).fork()).ldelim();
        }
        if (message.preferredAttachmentType !== 0) {
            writer.uint32(272).int32(message.preferredAttachmentType);
        }
        if (message.actualAttachmentType !== 0) {
            writer.uint32(280).int32(message.actualAttachmentType);
        }
        if (message.isExternalAttachment !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isExternalAttachment }, writer.uint32(290).fork()).ldelim();
        }
        if (message.swipeSensitivity !== undefined) {
            swipe_sensitivity_1.SwipeSensitivity.encode(message.swipeSensitivity, writer.uint32(298).fork()).ldelim();
        }
        if (message.exitEventSwipeInfo !== undefined) {
            exit_event_swipe_info_1.ExitEventSwipeInfo.encode(message.exitEventSwipeInfo, writer.uint32(306).fork()).ldelim();
        }
        for (const v of message.stickerMetadata) {
            sticker_metadata_1.StickerMetadata.encode(v, writer.uint32(314).fork()).ldelim();
        }
        if (message.adCtaCardType !== 0) {
            writer.uint32(320).int32(message.adCtaCardType);
        }
        if (message.adInteraction !== undefined) {
            ad_interaction_1.AdInteraction.encode(message.adInteraction, writer.uint32(330).fork()).ldelim();
        }
        if (message.attemptSwipeCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.attemptSwipeCount }, writer.uint32(338).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommonSnapAdImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.topsnapTimeViewedSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.topsnapMediaDurationSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.longformTimeViewedSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.swiped = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.deltaBetweenReceiveAndRenderMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.swipeCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.creativeId = reader.bytes();
                    break;
                case 8:
                    message.topsnapTimeViewedBeforeInteractionSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.topsnapVolumes = topsnap_volumes_1.TopsnapVolumes.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.topsnapMaxContinuousTimeViewedSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.topsnapAudibleTimeViewedSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.topsnapMediaType = reader.int32();
                    break;
                case 13:
                    message.wasPrefetched = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 14:
                    message.unskippableDurationSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 15:
                    message.unskippableViewTimeSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 16:
                    message.adSkippableType = reader.int32();
                    break;
                case 17:
                    message.fatalMediaLoadError = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 18:
                    message.wasBoosted = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 19:
                    message.autoEndCardInteractionCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 20:
                    message.dpa = dpa_metadata_1.DpaMetadata.decode(reader, reader.uint32());
                    break;
                case 21:
                    message.autoEndCardViewedCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 22:
                    message.adResponseParseCompleteTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 23:
                    message.adInsertionCompleteTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 24:
                    message.topsnapFullyPresentTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 25:
                    message.ctaInteractableTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 26:
                    message.attachmentPageLoadedTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 27:
                    message.attachmentTriggeredTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 28:
                    message.attachmentFullyPresentedTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 29:
                    message.attachmentDismissTriggerTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 30:
                    message.topsnapDimissTriggerTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 31:
                    message.ctaWillDisplayTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 32:
                    message.ctaDidDisplayTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 33:
                    message.topsnapPlaybackBeginTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 34:
                    message.preferredAttachmentType = reader.int32();
                    break;
                case 35:
                    message.actualAttachmentType = reader.int32();
                    break;
                case 36:
                    message.isExternalAttachment = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 37:
                    message.swipeSensitivity = swipe_sensitivity_1.SwipeSensitivity.decode(reader, reader.uint32());
                    break;
                case 38:
                    message.exitEventSwipeInfo = exit_event_swipe_info_1.ExitEventSwipeInfo.decode(reader, reader.uint32());
                    break;
                case 39:
                    message.stickerMetadata.push(sticker_metadata_1.StickerMetadata.decode(reader, reader.uint32()));
                    break;
                case 40:
                    message.adCtaCardType = reader.int32();
                    break;
                case 41:
                    message.adInteraction = ad_interaction_1.AdInteraction.decode(reader, reader.uint32());
                    break;
                case 42:
                    message.attemptSwipeCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCommonSnapAdImpressionTrack();
        message.topsnapTimeViewedSeconds =
            object.topsnapTimeViewedSeconds ?? undefined;
        message.topsnapMediaDurationSeconds =
            object.topsnapMediaDurationSeconds ?? undefined;
        message.longformTimeViewedSeconds =
            object.longformTimeViewedSeconds ?? undefined;
        message.swiped = object.swiped ?? undefined;
        message.deltaBetweenReceiveAndRenderMillis =
            object.deltaBetweenReceiveAndRenderMillis ?? undefined;
        message.swipeCount = object.swipeCount ?? undefined;
        message.creativeId = object.creativeId ?? new Uint8Array();
        message.topsnapTimeViewedBeforeInteractionSeconds =
            object.topsnapTimeViewedBeforeInteractionSeconds ?? undefined;
        message.topsnapVolumes =
            object.topsnapVolumes !== undefined && object.topsnapVolumes !== null
                ? topsnap_volumes_1.TopsnapVolumes.fromPartial(object.topsnapVolumes)
                : undefined;
        message.topsnapMaxContinuousTimeViewedSeconds =
            object.topsnapMaxContinuousTimeViewedSeconds ?? undefined;
        message.topsnapAudibleTimeViewedSeconds =
            object.topsnapAudibleTimeViewedSeconds ?? undefined;
        message.topsnapMediaType = object.topsnapMediaType ?? 0;
        message.wasPrefetched = object.wasPrefetched ?? undefined;
        message.unskippableDurationSeconds =
            object.unskippableDurationSeconds ?? undefined;
        message.unskippableViewTimeSeconds =
            object.unskippableViewTimeSeconds ?? undefined;
        message.adSkippableType = object.adSkippableType ?? 0;
        message.fatalMediaLoadError = object.fatalMediaLoadError ?? undefined;
        message.wasBoosted = object.wasBoosted ?? undefined;
        message.autoEndCardInteractionCount =
            object.autoEndCardInteractionCount ?? undefined;
        message.dpa =
            object.dpa !== undefined && object.dpa !== null
                ? dpa_metadata_1.DpaMetadata.fromPartial(object.dpa)
                : undefined;
        message.autoEndCardViewedCount = object.autoEndCardViewedCount ?? undefined;
        message.adResponseParseCompleteTsMs =
            object.adResponseParseCompleteTsMs ?? undefined;
        message.adInsertionCompleteTsMs =
            object.adInsertionCompleteTsMs ?? undefined;
        message.topsnapFullyPresentTsMs =
            object.topsnapFullyPresentTsMs ?? undefined;
        message.ctaInteractableTsMs = object.ctaInteractableTsMs ?? undefined;
        message.attachmentPageLoadedTsMs =
            object.attachmentPageLoadedTsMs ?? undefined;
        message.attachmentTriggeredTsMs =
            object.attachmentTriggeredTsMs ?? undefined;
        message.attachmentFullyPresentedTsMs =
            object.attachmentFullyPresentedTsMs ?? undefined;
        message.attachmentDismissTriggerTsMs =
            object.attachmentDismissTriggerTsMs ?? undefined;
        message.topsnapDimissTriggerTsMs =
            object.topsnapDimissTriggerTsMs ?? undefined;
        message.ctaWillDisplayTsMs = object.ctaWillDisplayTsMs ?? undefined;
        message.ctaDidDisplayTsMs = object.ctaDidDisplayTsMs ?? undefined;
        message.topsnapPlaybackBeginTsMs =
            object.topsnapPlaybackBeginTsMs ?? undefined;
        message.preferredAttachmentType = object.preferredAttachmentType ?? 0;
        message.actualAttachmentType = object.actualAttachmentType ?? 0;
        message.isExternalAttachment = object.isExternalAttachment ?? undefined;
        message.swipeSensitivity =
            object.swipeSensitivity !== undefined && object.swipeSensitivity !== null
                ? swipe_sensitivity_1.SwipeSensitivity.fromPartial(object.swipeSensitivity)
                : undefined;
        message.exitEventSwipeInfo =
            object.exitEventSwipeInfo !== undefined &&
                object.exitEventSwipeInfo !== null
                ? exit_event_swipe_info_1.ExitEventSwipeInfo.fromPartial(object.exitEventSwipeInfo)
                : undefined;
        message.stickerMetadata =
            object.stickerMetadata?.map((e) => sticker_metadata_1.StickerMetadata.fromPartial(e)) || [];
        message.adCtaCardType = object.adCtaCardType ?? 0;
        message.adInteraction =
            object.adInteraction !== undefined && object.adInteraction !== null
                ? ad_interaction_1.AdInteraction.fromPartial(object.adInteraction)
                : undefined;
        message.attemptSwipeCount = object.attemptSwipeCount ?? undefined;
        return message;
    },
};
//# sourceMappingURL=common_snap_ad_impression_track.js.map